import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import MaterialBox from "../../components/MaterialBox";
import MaterialButton from "../../components/MaterialButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import MaterialSelect from "../../components/MasterSelect";
import {
  AllContactDetailsQuery,
  getAllContactDetailsOptions,
  getAllOpportunityTypeOptions,
  getAllSalesStageOptions,
  getContactDetailsByMasterOptions,
  getContactDetailsByUserOptions,
  getOpportunity,
  getOpportunityTypeByMasterOptions,
  getOpportunityTypeByUserOptions,
  getSalesStageByMasterOptions,
  getSalesStageByUserOptions,
  ConvertToQuotation,
} from "../../lib/graphQL/graphQuery";
import {
  AddOpportunityMutation,
  updateOpportunity,
} from "../../lib/graphQL/graphMutation";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteOpportunityService,
  updateOpportuniService,
} from "../../lib/appUtliz/OpportunitService";
import { useLoading } from "../../context/LodingContext";
import { useError } from "../../context/ErrorContext";
import { useSuccess } from "../../context/SucccessContext";
import { useOppurtunityId } from "./OppurtunityContext";
import { useCustomer } from "../../context/apiContext/CustomerContext";
import { useLeadAndProscpect } from "../../context/apiContext/Lead-and-ProspectContext";
import StatusBar from "./StatusBar";
export default function AddOpportunity() {
  const [isFocused, setIsFocused] = useState(null);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => { },
    onCancel: () => { },
    done: "",
    back: "",
  });
  const [selectedData, setSelectedData] = useState([]);
  const [dropDownValues, setDropDownValues] = useState({
    type: "",
  });
  const today = new Date();
  const minDate = today.toISOString().split("T")[0];
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } =
    useError();
  const [pendingLoading, setPendingLoading] = useState(false);

  const [opportunityTypeData, setOpportunityTypeData] = useState([]);
  const [salesStageData, setSalesStageData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [selectedContact, setSelectedContact] = useState([]);
  const { currentUser } = useAuth();
  const [opportunityData, setOpportunityData] = useState({
    // Opportunity Details
    opportunityType: "",
    // salesStage: "",
    opportunityFrom: "",
    source: "",
    contact: "",
    customerOrLeadName: "",
    opportunityOwner: currentUser?.username,
    winProbability: "",
    status: "Open",
    opportunityAmount: "",
    expectedClosingDate: "",
    // stage: "",

    // Opportunity Status
    opportunityTypeStatus: "unchecked",
    // stageStatus: "unchecked",
    // salesStageStatus: "unchecked",
    opportunityFromStatus: "unchecked",
    sourceStatus: "unchecked",
    contactStatus: "unchecked",
    customerOrLeadNameStatus: "unchecked",
    opportunityOwnerStatus: "unchecked",
    winProbabilityStatus: "unchecked",
    opportunityAmountStatus: "unchecked",
    expectedClosingDateStatus: "unchecked",
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const navigate = useNavigate();
  const params = useLocation();
  const id = params.search.slice(1);
  const isUser = currentUser?.role;
  const { idValue, setIdValue } = useOppurtunityId();
  const { customerData, setCustomerData } = useCustomer();
  const { leadData, setLeadData } = useLeadAndProscpect();
  const [customerAndLead, setCustomerAndLead] = useState([]);
  const oppturnityStageOption = [
    "Presentation",
    "Proposal",
    // "Negotiation",
    // "Contracting",
    "Closed Won",
    "SO Converted",
    "Closed Lost",
  ];

  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);
  const OpportunityFromOptions = [
    {
      id: "Customer",
      value: "Customer",
    },
    {
      id: "Lead and Prospect",
      value: "Prospect",
    },
    // {
    //   id: "Prospect",
    //   value: "Prospect",
    // },
  ];
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getOpportunity, {
        id: id,
      });
      const v = res.getOpportunity;


      const filterOpprtunityOptions = OpportunityFromOptions.filter(
        (type) => {
          if (type.value == v.opportunityFrom) {
            return type;
          }
        }
      );

      const customerOrLeadNameValue = () => {
        if (v?.opportunityFrom == "Customer") {
          const filter = customerData.filter((val, i) => {
            if (val?.id == v?.customerOrLeadName) {
              return val?.legalName;
            }
          });

          return filter;
        } else if (v?.opportunityFrom == "Prospect") {
          const filter = leadData.filter((val, i) => {
            if (val?.id == v?.customerOrLeadName) {
              return val?.companyName;
            }
          });

          return filter;
        }
      };

      const data = customerOrLeadNameValue();

      setDropDownValues({
        type: filterOpprtunityOptions,
      });

      setSelectedData(v);
      // setIdValue(v);
      setOpportunityData({
        opportunityType: {
          value: v.opportunityType.id,
          label: v.opportunityType.typeName,
        },
        // salesStage: {
        //   value: v.salesStage.id,
        //   label: v.salesStage.stageName,
        // },
        opportunityFrom: {
          value: filterOpprtunityOptions[0].id,
          label: filterOpprtunityOptions[0].value,
        },
        customerOrLeadName: {
          value: data[0]?.id,
          label: data[0]?.legalName || data[0]?.companyName,
        },
        // stage: {
        //   value: v.stage,
        //   label: v.stage,
        // },
        source: v.Source,
        contact: { value: v.contact.id, label: v.contact.firstName },
        opportunityOwner: v.opportunityOwner,
        winProbability: v.winProbability,
        status: "Open",
        opportunityAmount: v.opportunityAmount,
        expectedClosingDate: v.expectedClosingDate,

        // Opportunity Status
        opportunityTypeStatus: "success",
        // salesStageStatus: "success",
        opportunityFromStatus: "success",
        sourceStatus: "success",
        contactStatus: "success",
        // stageStatus: "success",
        // customerLeadProspectStatus: "success",
        customerOrLeadNameStatus: "success",
        opportunityOwnerStatus: "success",
        winProbabilityStatus: "success",
        opportunityAmountStatus: "success",
        expectedClosingDateStatus: "success",
      });

    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setOpportunityData({
      opportunityType: {
        value: selectedData?.opportunityType?.id,
        label: selectedData?.opportunityType?.typeName,
      },
      // salesStage: {
      //   value: selectedData?.salesStage?.id,
      //   label: selectedData?.salesStage?.stageName,
      // },
      customerOrLeadName: {
        value: selectedData?.relatedName,
        label: selectedData?.relatedName,
      },
      // stage: {
      //   value: selectedData.stage,
      //   label: selectedData.stage,
      // },
      opportunityFrom: {
        value: dropDownValues.type[0].id,
        label: dropDownValues.type[0]?.value,
      },
      source: selectedData.Source,
      contact: {
        value: selectedData?.contact?.id,
        label: selectedData?.contact?.firstName,
      },
      // customerLeadProspect: "",
      opportunityOwner: currentUser?.username,
      winProbability: selectedData?.winProbability,
      status: "Open",
      opportunityAmount: selectedData?.opportunityAmount,
      expectedClosingDate: selectedData?.expectedClosingDate,
      customerOrLeadNameStatus: "success",
      opportunityTypeStatus: "success",
      // salesStageStatus: "success",
      opportunityFromStatus: "success",
      sourceStatus: "success",
      contactStatus: "success",
      // stageStatus: "success",
      // customerLeadProspectStatus: "success",
      opportunityOwnerStatus: "success",
      winProbabilityStatus: "success",
      opportunityAmountStatus: "success",
      expectedClosingDateStatus: "success",
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handleOpportunityDataChange = (event, selectEvent) => {
    let opportunityState = { ...opportunityData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "opportunityType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              opportunityState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              opportunityState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        // case "stage":
        //   {
        //     const lengthRegex = new RegExp("^[A-Za-z0-9]");
        //     if (lengthRegex.test(event?.label) === true) {
        //       opportunityState[selectEvent.name + "Status"] =
        //         event?.label === undefined ? "unchecked" : "success";
        //     } else {
        //       opportunityState[selectEvent.name + "Status"] =
        //         selectEvent.value === "" ? "unchecked" : "error";
        //     }
        //   }
        //   break;
        // case "salesStage":
        //   {
        //     const lengthRegex = new RegExp("^[A-Za-z0-9]");
        //     if (lengthRegex.test(event?.label) === true) {
        //       opportunityState[selectEvent.name + "Status"] =
        //         event?.label === undefined ? "unchecked" : "success";
        //     } else {
        //       opportunityState[selectEvent.name + "Status"] =
        //         selectEvent.value === "" ? "unchecked" : "error";
        //     }
        //   }
        //   break;
        case "opportunityFrom":
          const fileroption = event?.label.toLowerCase();
          if (fileroption == "customer") {
            setCustomerAndLead(customerData);
          } else if (fileroption == "prospect") {
            setCustomerAndLead(leadData);
          } else {
            opportunityState["customerOrLeadName"] = "";
            setCustomerAndLead([]);
          }

          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              opportunityState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              opportunityState["customerOrLeadName"] = "";
              opportunityState["customerOrLeadNameStatus"] = "unchecked";
              opportunityState["contact"] = "";
              opportunityState["contactStatus"] = "unchecked";
            } else {
              opportunityState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              opportunityState["customerOrLeadName"] = "";
              opportunityState["customerOrLeadNameStatus"] = "unchecked";
              opportunityState["contact"] = "";
              opportunityState["contactStatus"] = "unchecked";
            }
          }
          break;
        case "customerOrLeadName":
          const nameCondition = event?.label?.toLowerCase();
          // const fileroption = event?.label.toLowerCase();
          // if (fileroption == "customer") {
          //   setCustomerAndLead(customerData)
          // } else if (fileroption == "lead and prospect") {
          //   setCustomerAndLead(leadData)
          // }
          // const contactfilter = contactData.filter((v, i) => {
          //   if (v?.organizationType == fileroption) {
          //     return v;
          //   }
          // });
          // setSelectedContact(contactfilter);
          // const customerfliter=
          request(BASEURL, AllContactDetailsQuery, {
            id: event?.target?.value,
          }).then((res) => {
            const v = res.allContact;

            const filterData = v?.filter((v) => {
              if (v?.organizationName.toLowerCase() == nameCondition) {
                return v;
              }
            });
            setSelectedContact(filterData);
          });

          {
            const lengthRegex = new RegExp("^.*");
            if (lengthRegex.test(event?.label) === true) {
              opportunityState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              opportunityState["contact"] = "";
              opportunityState["contactStatus"] = "unchecked";
            } else {
              opportunityState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              opportunityState["contact"] = "";
              opportunityState["contactStatus"] = "unchecked";
            }
          }
          break;
        case "contact":
          {
            const lengthRegex = new RegExp("^.*");
            if (lengthRegex.test(event?.label) === true) {
              opportunityState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              opportunityState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      opportunityState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "source":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              opportunityState[event.target.name + "Status"] = "success";
            } else {
              opportunityState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "customerLeadProspect":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              opportunityState[event.target.name + "Status"] = "success";
            } else {
              opportunityState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "opportunityOwner":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              opportunityState[event.target.name + "Status"] = "success";
            } else {
              opportunityState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "winProbability":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,3})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              opportunityState[event.target.name + "Status"] = "success";
            } else {
              opportunityState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "status":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              opportunityState[event.target.name + "Status"] = "success";
            } else {
              opportunityState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "opportunityAmount":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{2,7})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              opportunityState[event.target.name + "Status"] = "success";
            } else {
              opportunityState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "expectedClosingDate":
          {
            const alphaNLenghthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              opportunityState[event.target.name + "Status"] = "success";
            } else {
              opportunityState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      opportunityState[event.target.name] = event.target.value;
    }

    setOpportunityData(opportunityState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      opportunityData.opportunityTypeStatus === "success" &&
      // opportunityData.salesStageStatus === "success" &&
      // opportunityData.stageStatus === "success" &&
      (opportunityData.opportunityFromStatus === "success" ||
        opportunityData.opportunityFromStatus === "unchecked") &&
      (opportunityData.sourceStatus === "success" ||
        opportunityData.sourceStatus === "unchecked") &&
      opportunityData.contactStatus === "success" &&
      opportunityData.customerOrLeadNameStatus === "success" &&
      opportunityData.opportunityOwnerStatus === "success" &&
      opportunityData.winProbabilityStatus === "success" &&
      // opportunityData.statusStatus === "success" &&
      opportunityData.opportunityAmountStatus === "success" &&
      opportunityData.expectedClosingDateStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddOpportunityData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        const values = {
          user: currentUser?.id,
          opportunityType: opportunityData.opportunityType?.value,
          opportunityFrom: opportunityData.opportunityFrom?.label,
          Source: opportunityData.source,
          contact: opportunityData.contact?.value,
          // customerOrLeadName: opportunityData.relatedName,
          customerOrLeadName: opportunityData.customerOrLeadName?.value,
          opportunityOwner: opportunityData.opportunityOwner,
          winProbability: parseInt(opportunityData.winProbability, 10),
          status: opportunityData.status,
          stage: "Open",
          opportunityAmount: parseInt(opportunityData.opportunityAmount, 10),
          expectedClosingDate: opportunityData.expectedClosingDate,
        };

        try {
          const response = await request(BASEURL, AddOpportunityMutation, {
            ...values,
          });
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setSuccessStatus(true);
          setSucessTitle("Opportunity Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/opportunity");
          }, 1000);
          //navigate("/opportunity");
        } catch (error) {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setErrorStatus(true);
          setErrormessage(error?.response?.errors[0]?.message);

          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        } finally {
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleEditOpportunityData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to update your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          user: currentUser?.id,
          opportunityType: opportunityData.opportunityType?.value,
          // salesStage: opportunityData.salesStage?.value,
          opportunityFrom: opportunityData.opportunityFrom?.label,
          Source: opportunityData.source,
          contact: opportunityData.contact?.value,
          opportunityOwner: opportunityData.opportunityOwner,
          customerOrLeadName: opportunityData.customerOrLeadName?.value,
          winProbability: parseInt(opportunityData.winProbability, 10),
          status: opportunityData.status,
          // stage: opportunityData?.stage?.label,
          opportunityAmount: parseInt(opportunityData.opportunityAmount, 10),
          expectedClosingDate: opportunityData.expectedClosingDate,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const { errormessage, updateStatus } = await updateOpportuniService(
          values,
          id
        );
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Opportunity Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/opportunity");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleCancelOpportunityData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/opportunity");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleDelteOpputunity = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await deleteOpportunityService(id);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Opportunity Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/opportunity");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const fetchData = () => {
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? getOpportunityTypeByMasterOptions
        : isUser.toLowerCase() == "employee"
          ? getOpportunityTypeByUserOptions
          : isUser.toLowerCase() == "superuser"
            ? getAllOpportunityTypeOptions
            : "Data Not Found",
      { id: currentUser?.id }
    ).then((res) => {
      setOpportunityTypeData(
        isUser.toLowerCase() == "manager"
          ? res.getOpportunitytypeByMaster
          : isUser.toLowerCase() == "employee"
            ? res.getOpportunitytypeByUser
            : isUser.toLowerCase() == "superuser"
              ? res.allOpportunitytype
              : []
      );
    });
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? getSalesStageByMasterOptions
        : isUser.toLowerCase() == "employee"
          ? getSalesStageByUserOptions
          : isUser.toLowerCase() == "superuser"
            ? getAllSalesStageOptions
            : "Data Not Found",
      { id: currentUser?.id }
    ).then((res) => {
      setSalesStageData(
        isUser.toLowerCase() == "manager"
          ? res.getSalesstageByMaster
          : isUser.toLowerCase() == "employee"
            ? res.getSalesstageByUser
            : isUser.toLowerCase() == "superuser"
              ? res.allSalesstage
              : []
      );
    });
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? getContactDetailsByMasterOptions
        : isUser.toLowerCase() == "employee"
          ? getContactDetailsByUserOptions
          : isUser.toLowerCase() == "superuser"
            ? getAllContactDetailsOptions
            : "Data Not Found",
      { id: currentUser?.id }
    ).then((res) => {
      setContactData(
        isUser.toLowerCase() == "manager"
          ? res.getContactdetailByMaster
          : isUser.toLowerCase() == "employee"
            ? res.getContactdetailByUser
            : isUser.toLowerCase() == "superuser"
              ? res.allContact
              : []
      );
    });

    if (opportunityData.opportunityOwner !== "") {
      setOpportunityData({
        ...opportunityData,
        opportunityOwnerStatus: "success",
      });
    } else {
      setOpportunityData({
        ...opportunityData,
        opportunityOwnerStatus: "unchecked",
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const convertQuation = async (id) => {

    if (!id) {
      console.error("Opportunity ID not found");

      return;
    }
    try {
      const response = await request(BASEURL, ConvertToQuotation, { id: id });

      if (response?.getOpportunity) {
        const opportunity = response.getOpportunity;

        const v = {
          opportunityID: { value: opportunity.id, label: opportunity.oppid },
          customer: { value: opportunity.relatedName, label: opportunity.relatedName },
          contactPerson: { value: opportunity.contact.id, label: opportunity.contact.firstName },
          opportunityFrom: { value: opportunity.opportunityFrom, label: opportunity.opportunityFrom },
        }
        setIdValue(v)

        navigate(`/quotation/add-quotation`, {
          state: {
            opportunityID: { value: opportunity.id, label: opportunity.oppid },
            customer: { value: opportunity.relatedName, label: opportunity.relatedName },
            contactPerson: { value: opportunity.contact.id, label: opportunity.contact.firstName },
            opportunityFrom: { value: opportunity.opportunityFrom, label: opportunity.opportunityFrom },
            type: "convert"
          },
        });
      }
    } catch (error) {
      console.error("Error fetching opportunity data:", error);
    }
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        {id && <StatusBar values={selectedData} />}
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Opportunity Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="contained"
                      color="dark"
                      onClick={() => convertQuation(id)}
                      startIcon={<EditIcon />}
                    >
                      Convert to Quotation
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={handleDelteOpputunity}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Opportunity Details
                    </MaterialTypography>

                  </Stack>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                </Stack>
              )
                : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h6" fontWeight="medium">
                        Add Opportunity Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
            </>
          }
        />
        <CardContent sx={{minHeight:'100%'}}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
            <BsFillPersonBadgeFill style={{ fontSize: 20, color: '#460058' }} />
            <MaterialTypography
              sx={{ color: '#460058', fontFamily: 'Aptos' }}
              component="label"
              variant="body2"
              fontWeight="700"
            >
              Opportunity Information
            </MaterialTypography>
          </Stack>
      
            <Grid container spacing={1}>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Opportunity Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="opportunityType"
                  size="small"
                  value={opportunityData.opportunityType}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={togglePage?.view === true ? true : false}
                  onChange={handleOpportunityDataChange} //selectedValue, event
                  options={opportunityTypeData?.map((item) => {
                    return {
                      value: item.id,
                      label: item.typeName,
                    };
                  })}
                  error={
                    opportunityData.opportunityTypeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityData.opportunityTypeStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Opportunity Amount <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="opportunityAmount"
                   size="small"
                  placeholder="Enter Amount"
                  value={opportunityData.opportunityAmount}
                  onChange={handleOpportunityDataChange}
                  error={
                    opportunityData.opportunityAmountStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityData.opportunityAmountStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {opportunityData.opportunityAmountStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Opportunity Amount should be maximum 7 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Opportunity From <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="opportunityFrom"
                   size="small"
                  value={opportunityData.opportunityFrom}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleOpportunityDataChange} //selectedValue, event
                  isDisabled={togglePage?.view === true ? true : false}
                  options={OpportunityFromOptions?.map((item) => {
                    return {
                      value: item.id,
                      label: item.value,
                    };
                  })}
                  error={
                    opportunityData.opportunityFromStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityData.opportunityFromStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Source
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="source"
                   size="small"
                  placeholder="Enter Source"
                  value={opportunityData.source}
                  onChange={handleOpportunityDataChange}
                  error={
                    opportunityData.sourceStatus === "error" ? true : false
                  }
                  success={
                    opportunityData.sourceStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {opportunityData.sourceStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Source should be maximum 25 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Organization Name<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customerOrLeadName"
                   size="small"
                  value={opportunityData.customerOrLeadName}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={togglePage?.view === true ? true : false}
                  onChange={handleOpportunityDataChange} //selectedValue, event
                  options={customerAndLead?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.legalName || item?.companyName,
                    };
                  })}
                  error={
                    opportunityData.customerOrLeadNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityData.customerOrLeadNameStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />

                {/* {opportunityData.customerOrLeadNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Customer/Lead/Prospect should be maximum 25 characters
                      long
                    </FormHelperText>
                  </FormControl>
                )} */}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Contact <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="contact"
                   size="small"
                  value={opportunityData.contact}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={togglePage?.view === true ? true : false}
                  onChange={handleOpportunityDataChange} //selectedValue, event
                  options={selectedContact?.map((item) => {
                    return {
                      value: item.id,
                      label: item.firstName,
                    };
                  })}
                  error={
                    opportunityData.contactStatus === "error" ? true : false
                  }
                  success={
                    opportunityData.contactStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Opportunity Owner <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="opportunityOwner"
                   size="small"
                  placeholder="Enter Source"
                  value={opportunityData.opportunityOwner}
                  onChange={handleOpportunityDataChange}
                  disabled={opportunityData.opportunityOwner}
                  error={
                    opportunityData.opportunityOwnerStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityData.opportunityOwnerStatus === "success"
                      ? true
                      : false
                  }
                />
                {opportunityData.opportunityOwnerStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Opportunity Owner should be maximum 25 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Win Probability <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="winProbability"
                  type="number"
                   size="small"
                  placeholder=""
                  value={opportunityData.winProbability}
                  onChange={handleOpportunityDataChange}
                  error={
                    opportunityData.winProbabilityStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityData.winProbabilityStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {opportunityData.winProbabilityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Win Probability should be allow 1 to 100
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Status <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="status"
                  size="small"
                  placeholder=""
                  value={opportunityData.status}
                  onChange={handleOpportunityDataChange}
                  disabled={opportunityData.status}
                  // error={
                  //   opportunityData.statusStatus === "error" ? true : false
                  // }
                  success={
                    opportunityData.statusStatus === "success" ? true : true
                  }
                />
                {opportunityData.statusStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Status should be Mandatory</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Expected Closing Date{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="expectedClosingDate"
                  type="date"
                   size="small"
                  placeholder="eg. 01-01-2024"
                  value={opportunityData.expectedClosingDate}
                  onChange={handleOpportunityDataChange}
                  error={
                    opportunityData.expectedClosingDateStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityData.expectedClosingDateStatus === "success"
                      ? true
                      : false
                  }
                  inputProps={{
                    min: minDate,
                  }}
                  disabled={togglePage?.view === true ? true : false}
                />
                {opportunityData.expectedClosingDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Expected Closing Date
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
         
        </CardContent>
        
        <MaterialBox
            display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4.5,  }}
        >
          {togglePage.edit === true ? (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={handleDiscardButton}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                size="small"
                disabled={!checkAllFields()}
                onClick={handleEditOpportunityData}
              >
                Update
              </MaterialButton>
            </>
          ) : togglePage.view === false && togglePage.edit === false ? (
            <MaterialBox p={2} display="flex" gap={2}>
             
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={handleCancelOpportunityData}
              >
                Cancel
              </MaterialButton>
               <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                disabled={!checkAllFields()}
                onClick={handleAddOpportunityData}
              >
                Submit
              </MaterialButton>
            </MaterialBox>
          ) : null}
         </MaterialBox>
      </Card>
    </DashboardLayout>
  );
}
